import React from "react";
import { Box, Typography } from "@mui/material";

const Group = () => {
  return (
    <Box
      sx={{
        py: { xs: 6, md: 10 },
        px: { xs: 2, sm: 3, md: 11 },
        backgroundColor: "transparent",
        display: "flex",
        justifyContent: "center",
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: { xs: "column", md: "row" },
          alignItems: "flex-start", // ✅ Top alignment for both text and image
          justifyContent: "space-between",
          gap: { xs: 4, md: 6 },
          maxWidth: "1710px",
          width: "100%",
        }}
      >
        {/* LEFT TEXT CONTENT */}
        <Box
          sx={{
            flex: 1,
            textAlign: { xs: "center", md: "left" },
          }}
          mt={{sm:4,md:8,}}
        >
          <Typography
            variant="subtitle1"
            color="rgba(25, 171, 226, 1)"
            sx={{
              fontWeight: 500,
              fontSize: "14px",
              mb: 1,
            }}
          >
            Why BBCorp Group?
          </Typography>

          <Typography
            variant="h2"
            lineHeight={1.2}
            sx={{
              fontSize: { xs: "2rem", sm: "2.5rem", md: "3rem" },
            }}
          >
            Empowering every client <br />with the best trading <br />experience possible.
          </Typography>

          <Typography
            sx={{
              mt: 2,
              fontSize: { xs: "1rem", sm: "1.125rem", md: "1.25rem" },
              color: "#607085",
              fontWeight: 400,
              lineHeight: 1.6,
            }}
          >
            Every client, regardless of account size, gets access to the same
            excellent trading conditions. Everyone who chooses BBCorp has the
            same opportunity to pursue their investment goals.
          </Typography>
        </Box>

        {/* RIGHT IMAGE */}
        <Box
          sx={{
            flex: 1,
            display: "flex",
            justifyContent: "center",
            alignItems: "flex-start", // ✅ Image aligns to the top
            p: { xs: 1, sm: 2 },
          }}
        >
          <Box
            component="img"
            src="/Images/whosidebanner.png"
            alt="side banner"
            sx={{
              width: "100%",
              maxWidth: 500,
              height: "auto",
              borderRadius: 2,
              objectFit: "contain",
            }}
          />
        </Box>
      </Box>
    </Box>
  );
};

export default Group;
